import { Fragment } from "react";

export function formatMultilineText(text: string): JSX.Element[] {
  const segments = text.split("\n");
  return segments.map((line, index) => (
    <Fragment key={`line-${index}`}>
      {line}
      {index < segments.length - 1 && <br />}
    </Fragment>
  ));
}
